const map = {
	"./check.svg": [
		4291,
		[
			291
		]
	],
	"./chevron-down.svg": [
		9871,
		[
			871
		]
	],
	"./close.svg": [
		703,
		[
			703
		]
	],
	"./copy.svg": [
		7630,
		[
			630
		]
	],
	"./crown-bronze.svg": [
		6728,
		[
			347
		]
	],
	"./crown-gold.svg": [
		5253,
		[
			253
		]
	],
	"./crown-silver.svg": [
		3920,
		[
			920
		]
	],
	"./crown.svg": [
		7050,
		[
			50
		]
	],
	"./discord.svg": [
		599,
		[
			599
		]
	],
	"./flag.svg": [
		6107,
		[
			107
		]
	],
	"./instagram.svg": [
		7147,
		[
			147
		]
	],
	"./list.svg": [
		5057,
		[
			57
		]
	],
	"./logout.svg": [
		6880,
		[
			499
		]
	],
	"./options.svg": [
		357,
		[
			357
		]
	],
	"./remove.svg": [
		9965,
		[
			965
		]
	],
	"./shopping-cart.svg": [
		8940,
		[
			940
		]
	],
	"./tick.svg": [
		2142,
		[
			142
		]
	],
	"./user.svg": [
		4188,
		[
			188
		]
	]
};
function webpackAsyncContext(req) {
	try {
		if(!__webpack_require__.o(map, req)) {
			return Promise.resolve().then(() => {
	const e = new Error("Cannot find module '" + req + "'");
	e.code = 'MODULE_NOT_FOUND';
	throw e;
});
		}
	} catch(err) {
		return Promise.reject(err);
	}

	const ids = map[req], id = ids[0];
	return __webpack_require__.e(ids[1][0]).then(() => (__webpack_require__(id)));
}
webpackAsyncContext.keys = () => (Object.keys(map));
webpackAsyncContext.id = 7917;
module.exports = webpackAsyncContext;